import script from "./TalentPoolForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TalentPoolForm.vue?vue&type=script&setup=true&lang=ts"

import "./TalentPoolForm.vue?vue&type=style&index=0&id=83e7f6ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e7f6ea"]])

export default __exports__